import { isValid } from '@pages/Client/Calendar/components/BulkEdit/helpers/isValidValidationNumber';

export function isMoreThanThirtyPercent(value?: number, baseValue?: number) {
  if (isNaN(Number(value)) || isNaN(Number(baseValue))) return true;
  return isValid(value) && isValid(baseValue) ? Number(value) > 0.29 * Number(baseValue) : false;
}
